import { useState, useEffect, useRef, useCallback } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig.js';

const getPokeBallImage = () => 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f30c.png';

const ICON_LIBRARY = [
    '🚀', '🛸', '🛰️', '🪐', '🌍', '🌎', '🌏', '🌕', '🌖', '🌗', '🌘', '🌑', '🌒', '🌓', '🌔',
    '☀️', '⭐', '🌟', '✨', '☄️', '🌌', '🌠', '👨‍🚀', '👩‍🚀', '👽', '👾', '🤖', '🔭', '🔬',
    '⚡', '🔥', '🌪️', '🌈', '🧊', '🌋', '🌊', '🧪', '⚙️', '🧭', '🛸'
];

const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>;
const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>;
const PlusIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>;

const ClassCard = ({ cr, onClassSelect, openEditModal, renderIcon }) => {
    const [stats, setStats] = useState({ count: 0, totalScore: 0 });

    useEffect(() => {
        const unsub = onSnapshot(collection(db, `classrooms/${cr.id}/students`), (snap) => {
            let total = 0;
            const count = snap.docs.length;
            snap.docs.forEach(doc => { total += (doc.data().score || 0); });
            setStats({ count, totalScore: total });
        });
        return () => unsub();
    }, [cr.id]);

    const average = stats.count > 0 ? (stats.totalScore / stats.count).toFixed(1) : '0.0';

    return (
        <div 
            onClick={() => onClassSelect(cr.id)}
            className="ct-student-card"
            style={{ 
                cursor: 'pointer', padding: '10px', display: 'flex', flexDirection: 'column',
                justifyContent: 'space-between', alignItems: 'center', 
                background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(12px)',
                transition: 'all 0.2s ease', position: 'relative', overflow: 'hidden', 
                border: '1px solid rgba(56, 189, 248, 0.25)', borderRadius: '16px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.5)'
            }}
            onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 0 20px rgba(56, 189, 248, 0.3)';
                e.currentTarget.style.borderColor = 'rgba(56, 189, 248, 0.6)';
            }}
            onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.5)';
                e.currentTarget.style.borderColor = 'rgba(56, 189, 248, 0.25)';
            }}
        >
            <button 
                onClick={(e) => openEditModal(e, cr)}
                style={{ position: 'absolute', top: '8px', left: '8px', background: 'rgba(30, 41, 59, 0.8)', border: '1px solid rgba(56,189,248,0.3)', borderRadius: '6px', padding: '6px', cursor: 'pointer', color: '#38bdf8', zIndex: 10, display: 'flex' }}
                title="Sınıf Bilgilerini Düzenle"
            >
                <EditIcon />
            </button>

            <div style={{ position: 'absolute', top: '8px', right: '8px', background: 'linear-gradient(135deg, #0284c7 0%, #2563eb 100%)', color: '#fff', padding: '4px 10px', borderRadius: '15px', fontSize: '0.85rem', fontWeight: 'bold', zIndex: 5, boxShadow: '0 2px 5px rgba(0,0,0,0.3)'}}>
                ⭐ {average}
            </div>

            <div className="ct-card-body" style={{ width: '100%', height: '100%', padding: 0, display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <div className="ct-avatar-area" style={{ flex: 3, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', minHeight: '0' }}>
                    {renderIcon(cr.icon)}
                </div>

                <div className="ct-name-area" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', zIndex: 2 }}>
                    <h2 style={{ margin: '0', color: '#e0f2fe', fontSize: 'clamp(1.2rem, 3vh, 2.1rem)', fontWeight: '900', lineHeight: '1.1', textShadow: '0 0 10px rgba(56,189,248,0.3)' }}>
                        {cr.name || cr.id}
                    </h2>
                    <p style={{ margin: '4px 0 0 0', color: '#38bdf8', fontSize: 'clamp(0.8rem, 1.6vh, 1rem)', fontWeight: '700', background: 'rgba(30, 41, 59, 0.8)', padding: '4px 12px', borderRadius: '10px', border: '1px solid rgba(56,189,248,0.2)' }}>
                        {stats.count} Mürettebat
                    </p>
                </div>
            </div>
        </div>
    );
};

const ClassListView = ({ classrooms, onClassSelect, onUpdateClass, onCreateClass, onDeleteClass }) => {
    const [gridStyle, setGridStyle] = useState({});
    const containerRef = useRef(null);
    const [modal, setModal] = useState({ isOpen: false, mode: 'add', classId: '', name: '', icon: '' });

    const calculateLayout = useCallback(() => {
        if (!containerRef.current) return;
        const count = classrooms.length;
        if (count === 0) return;

        const width = containerRef.current.clientWidth;
        const height = containerRef.current.clientHeight - 120; 
        const gap = 15; 

        let bestCols = 1, bestRows = 1, bestSize = 0;

        for (let cols = 1; cols <= count; cols++) {
            const rows = Math.ceil(count / cols);
            const size = Math.min((width - (cols - 1) * gap) / cols, (height - (rows - 1) * gap) / rows); 
            if (size > bestSize) { bestSize = size; bestCols = cols; bestRows = rows; }
        }

        setGridStyle({
            display: 'grid', gridTemplateColumns: `repeat(${bestCols}, 1fr)`,
            gridTemplateRows: `repeat(${bestRows}, minmax(0, 1fr))`, gap: `${gap}px`,
            width: '100%', height: '100%', padding: '10px', boxSizing: 'border-box'
        });
    }, [classrooms.length]); 

    useEffect(() => {
        calculateLayout();
        const observer = new ResizeObserver(calculateLayout);
        if (containerRef.current) observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, [calculateLayout]);

    const openAddModal = () => setModal({ isOpen: true, mode: 'add', classId: '', name: '', icon: '' });
    const openEditModal = (e, cr) => { e.stopPropagation(); setModal({ isOpen: true, mode: 'edit', classId: cr.id, name: cr.name || cr.id, icon: cr.icon || '' }); };

    const handleSaveClass = () => {
        if (modal.mode === 'add' && onCreateClass) onCreateClass(modal.name, modal.icon);
        else if (modal.mode === 'edit' && onUpdateClass) onUpdateClass(modal.classId, modal.name, modal.icon);
        setModal({ isOpen: false, mode: 'add', classId: '', name: '', icon: '' });
    };

    const handleDeleteClass = () => {
        if (window.confirm(`${modal.name} filosunu tamamen yok etmek istediğine emin misin?`)) {
            if (onDeleteClass) onDeleteClass(modal.classId);
            setModal({ isOpen: false, mode: 'add', classId: '', name: '', icon: '' });
        }
    };

    const renderIcon = (icon) => {
        if (!icon) return <img src={getPokeBallImage()} alt="Varsayılan" style={{ filter: 'drop-shadow(0 8px 15px rgba(0,0,0,0.5))', maxWidth: '65%', maxHeight: '65%', objectFit: 'contain' }} />;
        return <span style={{ fontSize: '5rem', filter: 'drop-shadow(0 0 15px rgba(56,189,248,0.5))', lineHeight: '1' }}>{icon}</span>;
    };

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', padding: '15px', overflow: 'hidden', position: 'relative' }}>
            
            <div style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', marginBottom: '10px', padding: '0 10px' }}>
                <h2 style={{ color: '#e0f2fe', margin: '0', fontWeight: '800', fontSize: 'clamp(1.5rem, 2.5vh, 2rem)', textShadow: '0 0 15px rgba(56,189,248,0.4)' }}>
                    <span style={{ color: '#38bdf8' }}>Galaktik</span> Filoları Yönet, Kaptan!
                </h2>
                <button 
                    onClick={openAddModal}
                    style={{ position: 'absolute', right: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 18px', background: 'linear-gradient(135deg, #0284c7 0%, #2563eb 100%)', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 4px 15px rgba(37, 99, 235, 0.4)', transition: 'transform 0.1s' }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                    <PlusIcon /> Yeni Filo
                </button>
            </div>

            <div style={{ flex: '1', minHeight: '0', position: 'relative' }}>
                <div ref={containerRef} style={{ width: '100%', height: '100%', position: 'absolute', inset: 0 }}>
                    <div className="ct-grid" style={gridStyle}>
                        {classrooms.sort((a, b) => a.id.localeCompare(b.id)).map((cr) => (
                            <ClassCard key={cr.id} cr={cr} onClassSelect={onClassSelect} openEditModal={openEditModal} renderIcon={renderIcon} />
                        ))}
                    </div>
                </div>
            </div>

            {/* KARANLIK TEMA MODAL EKRANI */}
            {modal.isOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(5px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                    <div style={{ background: 'rgba(15, 23, 42, 0.95)', border: '1px solid #38bdf8', width: '90%', maxWidth: '480px', borderRadius: '15px', padding: '25px', boxShadow: '0 0 30px rgba(56,189,248,0.2)', animation: 'scaleUp 0.2s ease' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid rgba(56,189,248,0.3)', paddingBottom: '15px' }}>
                            <h3 style={{ margin: 0, color: '#e0f2fe', fontSize: '1.5rem', textShadow: '0 0 10px rgba(56,189,248,0.5)' }}>
                                {modal.mode === 'add' ? 'Yeni Filo Oluştur' : 'Filoyu Özelleştir'}
                            </h3>
                            <button onClick={() => setModal({isOpen:false, mode:'add', classId:'', name:'', icon:''})} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8' }}><CloseIcon /></button>
                        </div>
                        
                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#94a3b8', fontSize: '0.95rem' }}>Filo Adı</label>
                            <input 
                                type="text" 
                                value={modal.name} 
                                onChange={(e) => setModal({...modal, name: e.target.value})}
                                placeholder="Örn: 5/B GALAKSİSİ"
                                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #38bdf8', background: 'rgba(30,41,59,0.8)', color: '#e0f2fe', boxSizing: 'border-box', fontSize: '1.1rem', fontWeight: '600', outline: 'none' }}
                            />
                        </div>

                        <div style={{ marginBottom: '25px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#94a3b8', fontSize: '0.95rem' }}>Simgesini Seç</label>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxHeight: '200px', overflowY: 'auto', padding: '10px', background: 'rgba(30,41,59,0.5)', borderRadius: '10px', border: '1px solid rgba(56,189,248,0.2)' }}>
                                <button 
                                    onClick={() => setModal({...modal, icon: ''})}
                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: modal.icon === '' ? 'rgba(56,189,248,0.2)' : 'transparent', border: modal.icon === '' ? '2px solid #38bdf8' : '1px solid rgba(56,189,248,0.2)', borderRadius: '8px', cursor: 'pointer' }}
                                    title="Varsayılan Simge"
                                >
                                    <img src={getPokeBallImage()} alt="Varsayılan" style={{ maxWidth: '80%', maxHeight: '80%', objectFit: 'contain' }} />
                                </button>
                                {ICON_LIBRARY.map((icon, idx) => (
                                    <button 
                                        key={idx}
                                        onClick={() => setModal({...modal, icon: icon})}
                                        style={{ fontSize: '1.8rem', width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: modal.icon === icon ? 'rgba(56,189,248,0.2)' : 'transparent', border: modal.icon === icon ? '2px solid #38bdf8' : '1px solid rgba(56,189,248,0.2)', borderRadius: '8px', cursor: 'pointer', transition: 'all 0.1s' }}
                                        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        {icon}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '10px' }}>
                            {modal.mode === 'edit' && (
                                <button 
                                    onClick={handleDeleteClass} title="Filoyu Yok Et"
                                    style={{ padding: '14px', background: 'rgba(220, 38, 38, 0.8)', color: '#fff', border: '1px solid #ef4444', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'opacity 0.2s' }}
                                >
                                    <TrashIcon />
                                </button>
                            )}
                            <button 
                                onClick={handleSaveClass} disabled={!modal.name.trim()}
                                style={{ flex: 1, padding: '14px', background: 'linear-gradient(135deg, #0284c7 0%, #2563eb 100%)', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '1.2rem', fontWeight: 'bold', cursor: 'pointer', transition: 'opacity 0.2s', opacity: !modal.name.trim() ? 0.6 : 1 }}
                            >
                                {modal.mode === 'add' ? 'Filoyu İnşa Et' : 'Sistemleri Güncelle'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ClassListView;